<template>
  <div class="favorite-card" @click="handleCardClick(`${favorite.timing_point_name}/${favorite.destination_name}`)">
    <countdown-card :propFrom="favorite.timing_point_name" :propTo="favorite.destination_name"/>
  </div>
</template>

<script>
import CountdownCard from '@/components/CountdownCard.vue'

export default {
  components: {
    CountdownCard
  },
  props: {
    favorite: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleCardClick (path) {
      this.$router.push(`/stops/${path}`)
    }
  },
}
</script>

<style lang="scss">
.favorite-card {
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;

  .box {
    position: relative;
    width: 100%;
    background: #fff;
    color: #000;
    border-radius: 5px;
  }

  .display-name {
    padding: 15px 20px;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    // text-align: center;
    color: #00A0E0;
    letter-spacing: 0.2px;

    svg {
      margin: 0 5px;
    }
  }

  .timers {
    padding: 15px 20px;
    display: flex;
    background-color: rgba(0,0,0,0.03);

    .timer {
      display: flex;
      align-items: center;
      padding: 0 20px;
      font-size: 18px;
      color: #C2C2C2;
      letter-spacing: 0.45px;

      &.main {
        padding: 0;
        color: #000;
        font-weight: 700;
        font-size: 25px;
        letter-spacing: 0.62px;
      }
    }
  }

  .return {
    display: none;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 40px;
    height: 40px;
    background: #F5A623;
    border-radius: 100%;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.7);
    }
  }

  .next,
  .favorite,
  .return-display-name {
    display: none;
  }
}
</style>
